import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ spacing, palette }) => ({
  about: {
    gridArea: "CirclesBanner",
    padding: `${spacing(5)}px ${spacing(5)}px`,
    display: "grid",
    gridTemplateColumns: "repeat(3, 20rem)",
    gridTemplateRows: "20rem",
    gap: spacing(2),
    justifyContent: "space-around",
    background: "white",
  },
  driver: {
    gridArea: "CirclesBanner",
    backgroundColor: "#ffffff",
    padding: `${spacing(5)}px ${spacing(5)}px`,
    display: "grid",
    gridTemplateColumns: "repeat(3, 20rem)",
    gridTemplateRows: "20rem",
    gap: spacing(2),
    justifyContent: "space-around",
  },
  circle: {
    border: `solid 18px ${palette.primary.main}`,
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
  },
  icon: {
    fontSize: "4em",
    color: "#133257",
  },
  iconAbout: {
    fontSize: "4em",
    color: "#ffffff",
  },
  text: {
    color: "#133257",
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "29px",
    textAlign: "center",
    width: "85%",
    margin: `0 0 ${spacing(5)}px 0`,
  },

  textMob: {
    color: "#133257",
    fontWeight: "bold",
    fontSize: "30px",
    textAlign: "center",
    width: "85%",
  },

  driverMob: {
    gridArea: "CirclesBanner",
    display: "flex",
    padding: "20px",

    flexDirection: "column",
  },
  iconMob: {
    fontSize: "8em",
    color: "#133257",
  },

  circleCont: {
    position: "relative",
    width: "100%",
    paddingBottom: "100%",
    marginBottom: "10px",
  },
  circleMob: {
    border: `solid 18px ${palette.primary.main}`,
    borderRadius: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    placeItems: "center",
    position: "absolute",
    width: "100%",
    height: "100%",
  },
}));

export default useStyles;
